module.exports = __webpack_public_path__ + "img/edit-note-icon.378221c8.svg";